import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import axios from 'axios';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

import { Button } from '@material-ui/core';
import EnhancedTableHead, {
  Transition,
  getComparator,
  stableSort,
} from '../../components/Common/EnhancedTableHead';
import 'toastr/build/toastr.min.css';
import { Delete, Edit, Visibility } from '@material-ui/icons';
import AddWordType from './AddWordType';
import DeleteDailog from '../../components/Common/DeleteDailog';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { baseUrl } from '../../helpers/EncryptionHelper';
import LoadIndicator from '../../components/Common/LoadIndicator';
import CustomSearchBar from '../../components/Common/CustomSearchBar';

const headCells = [
  {
    id: 'word_type_name',
    numeric: false,
    disablePadding: false,
    label: 'Word Type Name',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    align: 'center',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

// process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_BACKEND_ROUTE;

export default function CustomTableWordType() {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openDailog, setOpenDailog] = useState(false);
  const [openDeleteDailog, setOpenDeleteDailog] = useState(false);
  const [selectedWordType, setselectedWordType] = useState();

  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);

  const [editWordType, setEditWordType] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClose = () => {
    setselectedWordType();
    setEditWordType(false);
    setOpenDailog(false);
  };
  function handleCloseDeleteDailog() {
    setselectedWordType();
    setOpenDeleteDailog(false);
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // setOffset((s) => s + limit)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);

    setLimit(parseInt(event.target.value, 10));
    setOffset(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, (rows?.length || 0) - page * rowsPerPage);

  const handleDelete = async (id) => {
    axios
      .delete(baseUrl + `/part-of-speech/remove/${id}`)
      .then((res) => {
        if (res && res.data.status === 200) {
          handleCloseDeleteDailog();
          toastr.success('Word Type Deleted Successfully', 'Success');
          fetchData(0, limit);
          setOffset(0);
        }
      })
      .catch((error) => {
        toastr.error(`Word Type removal Failed`, 'Error!');
      });
  };

  const handleCloseAndRefresh = () => {
    setOpenDailog(false);
    setSelected([]);
    setTimeout(() => {
      fetchData(0, limit);
      setOffset(0);
    }, 200);
  };

  const fetchData = async (offset, limit) => {
    axios
      .get(baseUrl + `/part-of-speech?limit=${limit}&offset=${offset}`)
      .then((res) => {
        if (res && res.data.status === 200) {
          const list = res.data.data.partOfSpeeches || res.data.data.list || [];
          setRows(list);
          setTotalCount(
            parseInt(res.data.data.pagination?.totalCount || list.length) || 0
          );
          setShowLoader(false);
        }
      })
      .catch((err) => {
        console.log('error');
        setShowLoader(false);
      });
  };

  useEffect(() => {
    fetchData(offset, limit);
  }, [limit, offset]);

  const ITEMS_PER_PAGE = 10; // Number of items to display per page
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);

  const handleChange = (event, value) => {
    setShowLoader(true);
    setCurrentPage(value);
    setOffset((value - 1) * limit);
  };

  const currentData = rows || [];

  return (
    <div className={classes.root}>
      <Button
        style={{
          backgroundColor: '#257b59',
          color: 'white',
          padding: 10,
          alignSelf: 'flex-end',
          marginBottom: 20,
        }}
        onClick={() => {
          setselectedWordType();
          setOpenDailog(true);
        }}
      >
        Add WordType
      </Button>
      <Paper className={classes.paper}>
        {showLoader ? (
          <LoadIndicator />
        ) : (
          <>
            <CustomSearchBar
              rows={rows}
              setRows={setRows}
              keysToSearch={['word_type_name']}
            />
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby='tableTitle'
                size={dense ? 'small' : 'medium'}
                aria-label='enhanced table'
              >
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows?.length || 0}
                  headCells={headCells}
                />
                <TableBody>
                  {currentData.map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={index}>
                        <TableCell align='left'>
                          {row.word_type_name || row.name}
                        </TableCell>
                        <TableCell width={'30%'} align='center'>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setselectedWordType(row);
                              setOpenDailog(true);
                            }}
                          >
                            <Visibility />
                          </IconButton>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setEditWordType(true);
                              setselectedWordType(row);
                              setOpenDailog(true);
                            }}
                          >
                            <Edit />
                          </IconButton>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setOpenDeleteDailog(true);
                              setselectedWordType(row);
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
              rowsPerPageOptions={[50, 100, 200]}
              component='div'
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            /> */}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handleChange}
                  color="primary"
                  variant="outlined" shape="rounded"
                />
              </Stack>
            </div>
          </>
        )}
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label='Dense padding'
      />

      {openDailog && (
        <AddWordType
          data={selectedWordType}
          visible={openDailog}
          handleClose={handleClose}
          Transition={Transition}
          editWordType={editWordType}
        />
      )}
      {openDeleteDailog && (
        <DeleteDailog
          data={selectedWordType}
          visible={openDeleteDailog}
          handleClose={handleCloseDeleteDailog}
          Transition={Transition}
          dialogTitle={() => (
            <div className='mt-3'>
              Do you want to delete this WordType :{' '}
              <strong>{selectedWordType?.word_type_name || 'NA'}</strong>
            </div>
          )}
          handleDeleteClicked={(data) => handleDelete(data?.word_type_id)}
        />
      )}
    </div>
  );
}
